import { createApp } from 'vue';
import BroadbandLabel from '../components/broadband-label.vue';
import utility from './utility';

const vueBroadbandLabel = Array.from(document.getElementsByClassName('broadband-label'));
vueBroadbandLabel.forEach((element) => {
  let areaId = utility.makeid(6);
  if (element.id !== '') {
    areaId = element.id;
  } else {
    element.id = `speed-label-${areaId}`;
    areaId = `speed-label-${areaId}`;
  }
  const d_url = element.getAttribute('url');
  const d_height = element.getAttribute('height');
  const d_width = element.getAttribute('width');
  createApp({
    components: {
      BroadbandLabel,
    },
    template: `<broadband-label :url="'${d_url}'" :height="'${d_height}'" :width="'${d_width}'" style="margin-top:10px;"></broadband-label>`,
  }).mount(`#${areaId}`);
});
